import React from "react"
import { StyleSheet, Text, View } from "react-native"
import { useMediaQuery } from "react-responsive"

import Base from "../../../../base"
import { CustomSwitch } from "../../../common"
import Gap from "../../../common/Gap"

export default function ChoiceRow(props) {
  const isMobile = useMediaQuery(Base.constants.mobile)

  function stockChange(value) {
    props.onStockChange(props.item, !!value)
  }

  function statusChange(value) {
    props.onStatusChange(props.item, !!value)
  }

  return (
    <View style={[styles.main, props.style]}>
      <Text style={styles.title}>{props.item?.name}</Text>
      <View style={styles.switches}>
        <CustomSwitch
          value={props.item.enabled}
          onValueChange={statusChange}
          small
        />
        <CustomSwitch
          value={props.item.inStock}
          onValueChange={stockChange}
          small
          hidden={
            !!props.isFlooid &&
            !["ADDITION", "CHOICE"].includes(props.choiceGroupType)
          }
        />
      </View>
      <Gap size={isMobile ? 20 : 80} horizontal />
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    flexDirection: "row",
    minHeight: 48,
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomColor: Base.colours.appSemiLightGrey,
    borderBottomWidth: 1,
  },

  title: {
    flex: 1,
    paddingEnd: 10,
    fontSize: 16,
    color: Base.colours.appBlack,
    fontFamily: Base.fonts.appRegular,
    flexShrink: 1,
  },

  switches: {
    flexDirection: "row",
  },
})
